import Api from 'api';
import Body from './_main';
import './_styles/index.scss';
import Cookies from 'universal-cookie';
import React, { Component } from 'react';
import { Navigation, Footer } from 'components';

export default class Fulfillment extends Component {

  constructor(props) {
    super(props);
    this.api = new Api();
    this.cookies = new Cookies();
    this.state = { payment: {}, order: {}, loading: true }
  }

  componentDidMount = async () => {

    const { id } = this.props.match.params;

    const payment = await this.api.payment(id);

    if (!!payment.error) return this.setState({ loading: false });

    const order = await this.api.document('checkout',payment.checkout_id);

    return this.setState({ payment: payment, order: order, loading: false });

  }

  render() {

    const { order, payment, loading } = this.state;

    return (
      <section className='Checkout-Complete'>
        <Navigation/>
        <Body state={{payment,order,loading}}/>
        <Footer/>
      </section>
    )
  }
}
